<div class="min-h-screen bg-gray-50 dark:bg-gray-900 pb-20">
  <div class="max-w-3xl mx-auto px-4 pt-3 pb-4">
    <section class="mb-[17px] px-1">
      <app-page-title title="Instrumentos de avaliação"></app-page-title>
    </section>

    <section *ngIf="!turmaSemCalendario && !turmaEjaModular" class="mb-[17px] px-1">
      <button
        type="button"
        (click)="openCadInstrumentoAvaliacao()"
        class="inline-flex h-[2.65rem] items-center gap-2 rounded-md bg-[#3f79d8] px-4 text-white transition-all duration-200 hover:bg-[#356fcc]"
      >
        <lucide-icon name="plus" class="w-4 h-4"></lucide-icon>
        <span class="text-sm font-medium">Instrumento</span>
      </button>
    </section>

    <section class="px-1 instrumento-cards-section">
      <app-empty-state
        *ngIf="turmaSemCalendario"
        icone="alert-triangle"
        tema="yellow"
        titulo="Esta turma não possui calendário escolar definido"
        descricao="Procure o(a) secretário(a) do seu estabelecimento de ensino para preencher estas informações no Cadastro de Turmas">
      </app-empty-state>

      <app-empty-state
        *ngIf="turmaEjaModular"
        icone="ban"
        tema="yellow"
        titulo="Turma de EJA modular"
        descricao="Não é possível criar Instrumentos de avaliação para turmas de EJA modular.">
      </app-empty-state>

      <div *ngIf="!turmaSemCalendario && !turmaEjaModular && !instrumentosTelaResumo.length" class="border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 shadow-sm mt-4">
        <app-empty-state
          icone="notebook-pen"
          tema="yellow">
          <div class="text-sm text-slate-600 dark:text-slate-400 max-w-sm mx-auto flex flex-col gap-4">
            <p>Ainda não há instrumentos de avaliação cadastrados.</p>
            <p>Clique no botão <strong class="font-bold text-slate-800 dark:text-slate-200">+Instrumento</strong> acima e cadastre um novo instrumento.</p>
          </div>
        </app-empty-state>
      </div>

      <div *ngIf="!turmaEjaModular && instrumentosTelaResumo.length" class="instrumento-card-list space-y-3">
        <article *ngFor="let instrumento of instrumentosTelaResumo; trackBy: trackByInstrumentoResumo" class="instrumento-card rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900/40">
          <div class="instrumento-card__content min-w-0">
            <div class="instrumento-card__title flex flex-wrap items-baseline gap-x-1.5 gap-y-1">
              <span class="text-sm font-semibold text-[#3e5ad8] dark:text-blue-300 truncate">{{ instrumento.sigla || '—' }}</span>
              <span class="text-sm font-medium text-gray-900 dark:text-gray-100 break-words">{{ instrumento.descricao }}</span>
            </div>

            <p class="instrumento-card__meta text-sm text-gray-500 dark:text-gray-400 leading-5 break-words">
              {{ getItemEducacionalDescricao(instrumento) }}
              <span *ngIf="instrumento.data"> | {{ instrumento.data | date:'dd/MM/yyyy' }}</span>
            </p>

            <div class="instrumento-card__badge">
              <span class="inline-flex items-center rounded-full bg-[#4b5bdc] px-2.5 py-1 text-[11px] font-medium text-white shadow-sm">
                <lucide-icon name="graduation-cap" class="mr-1 h-3.5 w-3.5"></lucide-icon>
                {{ instrumento.tipoInstrumentoLabel }}
              </span>
            </div>
          </div>

          <div class="instrumento-card__actions flex items-center justify-end gap-2">
            <button
              type="button"
              (click)="editarInstrumento(instrumento)"
              class="instrumento-card__action h-10 w-10 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-500 dark:text-gray-300 hover:border-blue-300 hover:text-blue-600 transition-colors flex items-center justify-center"
              [disabled]="isEdicaoInstrumentoBloqueada(instrumento)"
              title="Editar"
            >
              <lucide-icon name="edit-2" class="w-4 h-4"></lucide-icon>
            </button>

            <button
              type="button"
              (click)="confirmarExclusaoInstrumento(instrumento)"
              class="instrumento-card__action h-10 w-10 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-500 dark:text-gray-300 hover:border-red-300 hover:text-red-600 transition-colors flex items-center justify-center"
              [disabled]="isExclusaoInstrumentoBloqueada(instrumento)"
              title="Excluir"
            >
              <lucide-icon name="trash-2" class="w-4 h-4"></lucide-icon>
            </button>
          </div>
        </article>
      </div>
    </section>
  </div>

  <app-instrumento-avaliacao-modal #instrumentoModalRef [vm]="vm"></app-instrumento-avaliacao-modal>

  <div *ngIf="carregandoInicial" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
    <div class="bg-white dark:bg-gray-800 rounded-md p-8 flex flex-col items-center shadow-lg max-w-md mx-4">
      <div class="mb-4">
        <div class="animate-spin rounded-full w-12 h-12 border-[3px] border-blue-500 border-t-transparent"
          role="status">
          <span class="sr-only">Carregando...</span>
        </div>
      </div>
      <h4 class="text-lg font-semibold text-gray-800 dark:text-gray-100">Carregando dados...</h4>
    </div>
  </div>

</div>